import { NEW_BUILDING } from 'constants/constants';
import * as yup from 'yup';
import { getPartOfValidationSchema } from '../../helpers';

const validationSchema = yup
  .object()
  .shape({ ...getPartOfValidationSchema({ projectType: NEW_BUILDING, groupName: 'outdoor' }) });

export default validationSchema;
